import {CellMeta, ExternalForecastPeriod, ExternalForecastYear} from "./external-forecast.model";
import {ComparisonRow} from "./external-forecast.rows";

// Pure per-cell rules (phase-2-edit-discard spec section 3 Q10). period null = the Total (annual) column.

export function cellMetaOf(row: ComparisonRow, period: ExternalForecastPeriod | null, year: ExternalForecastYear): CellMeta | null {
  if (row.ctShare) {
    // CT shares are month-only edits
    return period?.cts.find(ct => ct.ctOid === row.ctOid)?.pctMeta ?? null;
  }
  if (!row.cellKey) {
    return null;
  }
  return (period ?? year.annual).cellMeta[row.cellKey] ?? null;
}

export function isEditableCell(row: ComparisonRow, period: ExternalForecastPeriod | null, year: ExternalForecastYear): boolean {
  return cellMetaOf(row, period, year)?.status === "EDITED";
}

function isPartialMonth(period: ExternalForecastPeriod): boolean {
  const [y, m] = period.period.split("-").map(Number);
  const pad = (n: number) => String(n).padStart(2, "0");
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return period.startDate !== `${y}-${pad(m)}-01` || period.endDate !== `${y}-${pad(m)}-${pad(last)}`;
}

export function cellStyleClasses(row: ComparisonRow, period: ExternalForecastPeriod | null): string[] {
  const value = period ? row.values[period.period] : row.total;
  const classes: string[] = [];
  const calculated = row.calculated
    || (!!period && ((row.field === "aiMix" && period.aiType === "VOLUME")
      || (row.field === "aiVolume" && period.aiType === "PERCENTAGE")
      // a month a yearly entry filled in is a calculated value; a month the planner typed is not
      || (row.field === "businessMetric" && period.businessMetricCalculated)));
  if (calculated) {
    classes.push("calculated-field");
  }
  if (period) {
    const meta = row.ctShare ? period.cts.find(ct => ct.ctOid === row.ctOid)?.pctMeta
      : row.cellKey ? period.cellMeta[row.cellKey] : null;
    if (meta?.status === "CLOSED") {
      classes.push("closed-field");
    }
    if (isPartialMonth(period)) {
      classes.push("partial-field");
    }
  }
  if (value != null && value < 0) {
    classes.push("negative-value");
  }
  return classes;
}
